import React from 'react'

const CoinInfo = () => {
  return (
    <div className='lg:w-2/3 flex items-start justify-center h-[600px]'>
    </div>
  )
}

export default CoinInfo